import { createContext, useState, useContext } from 'react';

const RoundsContext = createContext();

export const RoundsProvider = ({ children }) => {
    const [roundsMode, setRoundsMode] = useState(false);

    return (
        <RoundsContext.Provider value={{ roundsMode, setRoundsMode }}>
            {children}
        </RoundsContext.Provider>
    );
};

export const useRounds = () => {
    const context = useContext(RoundsContext);
    if (!context) {
        throw new Error('useRounds must be used within a RoundsProvider');
    }
    return context;
};
